import { createAuthClient } from 'better-auth/react';
import { emailOTPClient } from 'better-auth/client/plugins';

const baseURL =
  typeof window !== 'undefined' ? window.location.origin : '';

/**
 * BetterAuth client — must match worker `basePath` (`/api/better-auth`).
 * Uses cookies for the BetterAuth session; pair with app JWT from `/api/auth/session`.
 */
export const authClient = createAuthClient({
  baseURL,
  basePath: '/api/better-auth',
  plugins: [emailOTPClient()],
});
